"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var i18n_exports = {};
__export(i18n_exports, {
  default: () => i18n_default
});
module.exports = __toCommonJS(i18n_exports);
var import_i18next = require("i18next");
var import_i18next_http_backend = __toESM(require("i18next-http-backend"));
var import_react_i18next = require("react-i18next");
var import_env = require("./constants/env");
var import_i18next_browser_languagedetector = __toESM(require("i18next-browser-languagedetector"));
var import_i18n = require("./utils/i18n/i18n.util");
var _window;
var defaultNS = ["core-i18n"];
var atomicI18nInstance = (0, import_i18next.createInstance)();
var hostname = typeof window !== "undefined" ? (_window = window) === null || _window === void 0 ? void 0 : _window.location.hostname : "localhost";
var m17nHostname = import_env.PLATFORM_UI_STRINGS_CDN_URL[hostname] ? import_env.PLATFORM_UI_STRINGS_CDN_URL[hostname] : import_env.PLATFORM_UI_STRINGS_CDN_URL["digital.dev.greatminds.dev"];
atomicI18nInstance.use(import_react_i18next.initReactI18next).use(import_i18next_browser_languagedetector.default).use(import_i18next_http_backend.default).init({
  lng: "en",
  fallbackLng: "en",
  debug: import_env.IS_LOCAL,
  preload: ["en", "de"],
  ns: defaultNS,
  defaultNS,
  react: {
    useSuspense: false
  },
  backend: {
    loadPath: "".concat(m17nHostname, "/").concat(import_env.PLATFORM_UI_STRINGS_CDN_SUBPATH, "/{{ns}}/").concat(import_env.PLATFORM_UI_STRINGS_CDN_VERSION, "/{{lng}}/{{lng}}.json")
  }
});
(0, import_i18n.addFormatters)(atomicI18nInstance);
var i18n_default = atomicI18nInstance;
//# sourceMappingURL=i18n.js.map